export default {
  recruiterHelpCenter: `Recruiter Help Center`,
};
